__turbopack_context__.v({
  "tabEqualSpace": "qOM_lW_tabEqualSpace",
  "tabLink": "qOM_lW_tabLink",
  "tabsRoot": "qOM_lW_tabsRoot",
  "tabsRootHardBg": "qOM_lW_tabsRootHardBg",
  "tabsRootHardBgPrimary": "qOM_lW_tabsRootHardBgPrimary",
  "tabsRootHardBgSecondary": "qOM_lW_tabsRootHardBgSecondary",
  "tabsRootListItemFull": "qOM_lW_tabsRootListItemFull",
});
